import { cisInstance } from './cis-instance';
import { ReviewerNew } from '@/types';

export const registerReviewerExpert = {
    create: (data: ReviewerNew): Promise<ReviewerNew> =>
        cisInstance.post<ReviewerNew>('RegisterReviewerExpert/Post', data).then(x => x.data),
};
